import 'common/reset.scss';
import './index.scss';
import 'common/elementUi.js';
import MessageBox from 'common/message-box';
import Vue from 'vue';
import App from './App.vue';
Vue.use(MessageBox);

new Vue({
  el: '#app',
  render: (h) => h(App)
});
